import {
  FilterValue,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import {
  isEmptySelectOptionStringArray,
  isCustomPeriodOption,
  isSelectOptionStringArray,
} from "./selectoption";

export const createFilterValueFromSelectOption = (
  filterId: string,
  option: SelectOption
): FilterValue => {
  const { dependsOnFilterId, dependentOfFilterId } = option;
  const value = isSelectOptionStringArray(option)
    ? (option.value[0] ?? "")
    : option.value;

  const isCustomPeriod = isCustomPeriodOption(option);
  return {
    filterId,
    value,
    ...(isCustomPeriod
      ? { startDate: option.startDate, endDate: option.endDate }
      : {}),
    dependsOnFilterId,
    dependentOfFilterId,
  };
};

export const createFilterValueFromMultiSelectOption = (
  filterId: string,
  option: SelectOption,
  currentFilterValue: StringArrayFilterValue,
  isSelected: boolean
): StringArrayFilterValue => {
  const { dependsOnFilterId, dependentOfFilterId } = option;
  if (isEmptySelectOptionStringArray(option)) {
    return {
      filterId,
      value: [],
      dependsOnFilterId,
      dependentOfFilterId,
    };
  }

  const currentValueSet = new Set(currentFilterValue.value);
  if (isSelectOptionStringArray(option)) {
    for (const value of option.value) {
      if (isSelected) {
        currentValueSet.delete(value);
      } else {
        currentValueSet.add(value);
      }
    }
  } else {
    if (isSelected) {
      currentValueSet.delete(option.value);
    } else {
      currentValueSet.add(option.value);
    }
  }

  return {
    filterId,
    value: [...currentValueSet],
    dependsOnFilterId,
    dependentOfFilterId,
  };
};
